/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PayApp/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
let FeatureFlags = React.lazy(() => import('./FeatureFlags/index'))



/** @type {import('Simple/types.js').View} */
export default function PayApp({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PayApp"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="PayApp.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z2g2Swd': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PayApp.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z2g2Swd': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Pay App"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Enable/disable some of the features that users can access from the Pay App."
/>
</div>
<div
  data-testid="PayApp.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-3-Z2g2Swd': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="PayApp.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-Z2g2Swd': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-4-Z2g2Swd': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-Z2g2Swd': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<FeatureFlags
{...childProps}
  viewPath={`${viewPath}/FeatureFlags`}
/>
)}
</SuspenseBoundary>
</div>
</div>
</div>
{children}
</React.Fragment>)
}